import React, { useState, useCallback, useEffect, forwardRef } from 'react';
import FormControl from '@mui/joy/FormControl';
import Button from '@mui/joy/Button';
import Typography from '@mui/joy/Typography';
import Input from '@mui/joy/Input';
import FormLabel from '@mui/joy/FormLabel';
import { styled } from '@mui/joy/styles';
import Sheet from '@mui/joy/Sheet';
import Box from '@mui/joy/Box';



//////////////// Alert
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

///////////////// Use Form
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';


import { uploadModelsFile } from '../../Api/Statistics';

const schema = yup.object({
    file: yup.mixed().required("يجب تحديد ملف")
})


const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const VisuallyHiddenInput = styled('input')`
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  bottom: 0;
  left: 0;
  white-space: nowrap;
  width: 1px;
`;


export default function UploadFileModelsComponent() {
    const [content, setContent] = useState(null)
    const [imageDataTwo, setImageDataTwo] = useState(null)
    const [urlImageName, setUrlImageName] = useState("قم برفع ملف الموديلات")

    const [loading, setLoading] = useState(false)
    const [openAlert, setOpenAlert] = useState(false);
    const [messageAlert, setMessageAlert] = useState('');

    const [openAlertError, setOpenAlertError] = useState(false);
    const [messageAlertError, setMessageAlertError] = useState('');

    const form = useForm({
        defaultValues: {
            file: null
        },
        resolver: yupResolver(schema)
    });
    const { register, handleSubmit, formState, setValue } = form;
    const { errors } = formState


    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false);
    };

    const handleCloseAlertError = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlertError(false);
    };

    const imgNews = (event) => {
        let image = event.target;
        if (image.files && image.files[0]) {
            setImageDataTwo(image.files[0]);
            // console.log(image.files[0])
            setUrlImageName(image.files[0].name)
            var reader = new FileReader();
            // reader.onload = (e) => {
            //     setUrlImage(e.target.result);
            // }
            reader.readAsDataURL(image.files[0]);
        }
    };

    const submitcontent = async (data) => {
        setLoading(true)
        if (data.file) {
            data.file = data.file[0]
        }
        try {
            const res = await uploadModelsFile(data)
            if (res) {
                setOpenAlert(true)
                setMessageAlert("تم رفع الملف بنجاح")
                setLoading(false)
                setValue('file', null)
                setUrlImageName('قم برفع ملف الموديلات')
            }
        } catch (error) {
            if (error.response) {
                setLoading(false)
                setOpenAlertError(true)
                setMessageAlertError(error.response.data.message)
            }
        }
    }

    return (
        <>
            <Snackbar open={openAlert} autoHideDuration={6000} onClose={handleClose}>
                <Alert severity="success">{messageAlert}</Alert>
            </Snackbar>

            <Snackbar open={openAlertError} autoHideDuration={6000} onClose={handleCloseAlertError}>
                <Alert onClose={handleCloseAlertError} severity="warning" sx={{ width: '100%' }}>
                    {messageAlertError}
                </Alert>
            </Snackbar>
            <form onSubmit={handleSubmit(submitcontent)}>
                {/* <FormControl sx={{margin:'50px 0', width:'40%'}}>
                    <FormLabel>الضريبة</FormLabel>
                    <Input 
                        type='number' 
                        placeholder="الضريبة" 
                        sx={{
                            marginTop:'10px',
                            height:'50px',
                            borderRadius:'25px'
                        }}
                        {...register('tax')}
                        />
                    {errors.tax &&
                        <Typography
                            color="danger"
                            level="body-xs"
                            variant="plain"
                        >{errors.tax?.message}</Typography>
                    }
                </FormControl> */}
                <FormControl>
                                    <FormLabel sx={{fontSize:'16px', color:'#434448'}}>ملف الموديلات</FormLabel>
                                    <Button
                                        component="label"
                                        role={undefined}
                                        tabIndex={-1}
                                        variant="outlined"
                                        color="neutral"
                                        sx={{ border: '1px solid #E6E6E6', padding: '0', position: 'relative', height: '60px', paddingLeft: '40%', borderRadius: '30px' }}
                                        endDecorator={
                                            <Box sx={{ backgroundColor: '#3E64F4', color: '#FFF', position: 'absolute', left: '0', top: '0', width: '30%', height: '60px', textAlign: 'center', lineHeight: '60px', borderRadius: '30px' }}>
                                                Upload
                                            </Box>
                                        }
                                    >
                                        {urlImageName}
                                        <VisuallyHiddenInput type="file" {...register('file')} onChange={(e) => imgNews(e)}/>
                                    </Button>
                                    {errors.file &&
                                        <Typography
                                            color="danger"
                                            level="body-xs"
                                            variant="plain"
                                        >{errors.file?.message}</Typography>
                                    }
                                </FormControl>
                <Button
                    variant='solid'
                    type='submit'
                    loading={loading}
                    sx={{ marginTop: '30px', width:'150px', backgroundColor: '#3E64F4', color: '#FFF', height: '60px', borderRadius: '30px',fontWeight:'bold' }}>
                     حفظ
                </Button>
            </form>
        </>
    )
}